import styled from '@emotion/styled'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import Breadcrumb from '../../../../components/common/Breadcrumb'
import {
  E_CLAIM_ENROLLMENT,
  E_CLAIM_LIST,
  useGetEClaimEnrollment,
  useGetEClaimList,
} from '../../../../services/e-claim/e-claim-query'
import { useRouter } from '../../../../utils/helper'
import { useScreen } from '../../../../utils/responsive-helper'
import Text from '../../../../components/common/Text'
import { FONT_BLACK } from '../../../../constant/colors'
import WellBeingList from './WellBeingList'
import WellBeingWelfare from './WellBeingWelfare'
import { useEffect, useMemo } from 'react'
import FooterContent from '../../../../components/FooterContent'
import { useHistory } from 'react-router'
import Button from '../../../../components/common/Button'
import { benefits } from '../../../../constant/path'
import Loading from '../../../../components/common/Loading'
import { useGetEnrollmentYear } from '../..'
import { QueryClient, useQueryClient } from 'react-query'
import { ENROLLMENTS } from '../../../../services/enrollment/enrollment-query'

const Layout = styled.div`
  margin-bottom: 40px;
`

const Row = styled.div`
  display: flex;
  flex-flow: row;
`

const BreadcrumbLayout = styled.div`
  margin-top: 24px;
`

const RowPaddingBottom = styled(Row)`
  margin-bottom: 16px;
`

const LayoutTitle = styled(Row)`
  justify-content: center;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 27px;
`

const ButtonStyle = styled(Button)`
  width: 267px;
`

const WellBeing = () => {
  const { query } = useRouter()
  const { isMobile } = useScreen()
  const history = useHistory()
  const queryClient = useQueryClient()
  const { enrollmentYear } = useGetEnrollmentYear()

  const { t } = useTranslation()
  const { data: eClaimEnrollment, isLoading: isLoadingEClaimEnrollment } = useGetEClaimEnrollment(
    query?.benefitYearId,
  )
  const { data: eClaimList, isLoading: isLoadingEClaimList } = useGetEClaimList()

  const reRenderEClaimEnrollment = useMemo(() => {
    return eClaimEnrollment
  }, [eClaimEnrollment])

  const reRenderEClaimList = useMemo(() => {
    return eClaimList
  }, [eClaimList])

  useEffect(() => {
    return () => {
      queryClient.invalidateQueries()
    }
  }, [queryClient])

  return (
    <Layout>
      {!isMobile && (
        <BreadcrumbLayout>
          <Breadcrumb
            overide={(paths) => {
              // paths.unshift({ label: 'Home', path: '/' })
              paths[0].label = t('ปรับเปลี่ยนสวัสดิการ')
              paths[1].label = t(`ดูสวัสดิการปี ${enrollmentYear}`)
              paths[2].label = t(`สวัสดิการปี ${enrollmentYear} ของฉัน`)
              paths[3].label = 'สวัสดิการเพิ่มเติม'
              return paths
            }}
          />
        </BreadcrumbLayout>
      )}
      <LayoutTitle>
        <Text size={28} type="Bold" color={FONT_BLACK}>
          สวัสดิการเพิ่มเติม
        </Text>
      </LayoutTitle>
      <RowPaddingBottom>
        <Text size={22} type="Bold" color={FONT_BLACK}>
          เลือกสวัสดิการที่ต้องการเบิก
        </Text>
      </RowPaddingBottom>
      <Loading loading={isLoadingEClaimEnrollment}>
        <WellBeingList eClaimEnrollment={reRenderEClaimEnrollment} />
      </Loading>
      <Loading loading={isLoadingEClaimList}>
        <WellBeingWelfare eClaimList={reRenderEClaimList} />
      </Loading>

      <FooterContent
        style={{
          height: 80,
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'flex-end',
          alignItems: 'center',
        }}
      >
        <ButtonStyle
          onClick={() => {
            history.push(
              benefits({
                routeParam: { benefitYearId: query?.benefitYearId || 1 },
              }),
            )
          }}
        >
          ยืนยัน
        </ButtonStyle>
      </FooterContent>
    </Layout>
  )
}

export default WellBeing
